import { Spot } from '@/types/spots';

export const sampleSpots: Spot[] = [
  {
    id: '1',
    name: 'The Hoxton, Southwark',
    address: '40 Blackfriars Rd, SE1 8NY',
    type: 'Hotel Lobby',
    category: 'hotel',
    description: 'Spacious lobby with comfortable seating, great for calls',
    coordinates: { lat: 51.5045, lng: -0.1045 },
    powerOutlets: 3,
    wifiQuality: 5,
    quietLevel: 3,
    seatAvailability: 4,
    openingHours: '7am - 11pm',
    callFriendly: true,
    nearestTube: 'Southwark',
    walkMinutes: 3,
    imageUrl: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/thehoxton',
    websiteUrl: 'https://thehoxton.com/london/southwark/',
  },
  {
    id: '2',
    name: 'Prufrock Coffee',
    address: '23-25 Leather Lane, EC1N 7TE',
    type: 'Specialty Cafe',
    category: 'cafe',
    description: 'Award-winning coffee, laptop-friendly with good vibes',
    coordinates: { lat: 51.5196, lng: -0.1091 },
    powerOutlets: 4,
    wifiQuality: 4,
    quietLevel: 2,
    seatAvailability: 3,
    openingHours: '8am - 6pm',
    callFriendly: false,
    nearestTube: 'Chancery Lane',
    walkMinutes: 4,
    imageUrl: 'https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/praborncoffee',
    websiteUrl: 'https://prufrockcoffee.com/',
  },
  {
    id: '3',
    name: 'The British Library',
    address: '96 Euston Road, NW1 2DB',
    type: 'National Library',
    category: 'library',
    description: 'Quiet reading rooms, free WiFi, perfect for focused work',
    coordinates: { lat: 51.5299, lng: -0.1277 },
    powerOutlets: 5,
    wifiQuality: 4,
    quietLevel: 5,
    seatAvailability: 3,
    openingHours: '9:30am - 8pm',
    callFriendly: false,
    nearestTube: 'King\'s Cross St Pancras',
    walkMinutes: 2,
    imageUrl: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/britishlibrary',
    websiteUrl: 'https://www.bl.uk/',
  },
  {
    id: '4',
    name: 'Bermonds Locke',
    address: '157 Tower Bridge Road, SE1 3LW',
    type: 'Aparthotel Coworking',
    category: 'coworking',
    description: 'Dedicated workspace with cafe, ideal for longer sessions',
    coordinates: { lat: 51.4978, lng: -0.0788 },
    powerOutlets: 5,
    wifiQuality: 5,
    quietLevel: 4,
    seatAvailability: 4,
    openingHours: '7am - 10pm',
    callFriendly: true,
    nearestTube: 'Borough',
    walkMinutes: 7,
    imageUrl: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/locabordeaux',
    websiteUrl: 'https://www.lockehotels.com/bermonds-locke/',
  },
  {
    id: '5',
    name: 'Southbank Centre',
    address: 'Belvedere Road, SE1 8XX',
    type: 'Cultural Hub',
    category: 'cultural',
    description: 'Large foyer spaces, cafes, and river views',
    coordinates: { lat: 51.5064, lng: -0.1164 },
    powerOutlets: 2,
    wifiQuality: 4,
    quietLevel: 2,
    seatAvailability: 4,
    openingHours: '10am - 11pm',
    callFriendly: true,
    nearestTube: 'Waterloo',
    walkMinutes: 4,
    imageUrl: 'https://images.unsplash.com/photo-1555448248-2571daf6344b?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/southbankcentre',
    websiteUrl: 'https://www.southbankcentre.co.uk/',
  },
  {
    id: '6',
    name: 'Clifton Nurseries Cafe',
    address: '5A Clifton Villas, W9 2PH',
    type: 'Garden Cafe',
    category: 'cafe',
    description: 'Peaceful garden setting, great for creative work',
    coordinates: { lat: 51.5263, lng: -0.1836 },
    powerOutlets: 2,
    wifiQuality: 3,
    quietLevel: 4,
    seatAvailability: 3,
    openingHours: '9am - 5pm',
    callFriendly: true,
    nearestTube: 'Warwick Avenue',
    walkMinutes: 5,
    imageUrl: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/cliftonnurseries',
    websiteUrl: 'https://www.clifton.co.uk/',
  },
  {
    id: '7',
    name: 'citizenM London Bankside',
    address: '20 Lavington St, SE1 0NZ',
    type: 'Hotel Lobby',
    category: 'hotel',
    description: 'Modern lobby with 24/7 access, stylish and comfortable',
    coordinates: { lat: 51.5054, lng: -0.0983 },
    powerOutlets: 4,
    wifiQuality: 5,
    quietLevel: 3,
    seatAvailability: 4,
    openingHours: '24/7',
    callFriendly: true,
    nearestTube: 'Southwark',
    walkMinutes: 5,
    imageUrl: 'https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/citizenm',
    websiteUrl: 'https://www.citizenm.com/hotels/europe/london/london-bankside-hotel',
  },
  {
    id: '8',
    name: 'Barbican Library',
    address: 'Level 2, Barbican Centre, Silk Street, EC2Y 8DS',
    type: 'Public Library',
    category: 'library',
    description: 'Modern library in iconic cultural center',
    coordinates: { lat: 51.5200, lng: -0.0940 },
    powerOutlets: 4,
    wifiQuality: 4,
    quietLevel: 5,
    seatAvailability: 3,
    openingHours: '9:30am - 5:30pm',
    callFriendly: false,
    nearestTube: 'Barbican',
    walkMinutes: 1,
    imageUrl: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/barbicancentre',
    websiteUrl: 'https://www.barbican.org.uk/whats-on/2023/event/barbican-library',
  },
  {
    id: '9',
    name: 'Mare Street Market',
    address: '117 Mare Street, E8 4RU',
    type: 'Concept Store & Cafe',
    category: 'cafe',
    description: 'Trendy space with food hall vibes, lively atmosphere',
    coordinates: { lat: 51.5440, lng: -0.0553 },
    powerOutlets: 3,
    wifiQuality: 4,
    quietLevel: 2,
    seatAvailability: 3,
    openingHours: '8am - 10pm',
    callFriendly: false,
    nearestTube: 'London Fields (Overground)',
    walkMinutes: 5,
    imageUrl: 'https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/marestreetmarket',
    websiteUrl: 'https://www.marestreetmarket.com/',
  },
  {
    id: '10',
    name: 'Two More Years',
    address: '7 Roach Rd, Fish Island, E3 2PA',
    type: 'Bar & Coworking',
    category: 'coworking',
    description: 'Canal-side venue, quiet during daytime',
    coordinates: { lat: 51.5375, lng: -0.0260 },
    powerOutlets: 4,
    wifiQuality: 4,
    quietLevel: 4,
    seatAvailability: 5,
    openingHours: '10am - midnight',
    callFriendly: true,
    nearestTube: 'Hackney Wick (Overground)',
    walkMinutes: 3,
    imageUrl: 'https://images.unsplash.com/photo-1572116469696-31de0f17cc34?w=400&h=300&fit=crop',
    instagramUrl: 'https://instagram.com/twomoreyears_',
    websiteUrl: 'https://twomoreyears.com/',
  },
];
